import Strings from "../constants/Strings";
import {
  buildRegisterPayload,
  type SignupFormFields,
} from "../helpers/buildRegisterPayload";
import api from "./api";

export type RegisterUserResult = { id: number; token: string };

export async function registerUser(
  fields: SignupFormFields,
): Promise<RegisterUserResult> {
  const payload = buildRegisterPayload(fields);
  const { data } = await api.post<RegisterUserResult>(
    "/users/register/",
    payload,
  );
  return data;
}

export function applyAuthToken(token: string): void {
  localStorage.setItem(Strings.token_jwt, token);
  api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

export function getRegisterErrorMessage(error: unknown): string {
  const err = error as {
    response?: { data?: { msg?: string; error?: string } };
  };
  return (
    err?.response?.data?.msg ||
    err?.response?.data?.error ||
    "Não foi possível concluir o cadastro."
  );
}
